// Fila de clientes do WhatsApp que pediram atendimento humano.
//
// Um único polling por aba, compartilhado por quem assinar: o sino do cabeçalho
// (lista) e a tela Delivery (som) leem o mesmo estado. Antes cada um buscava por
// conta própria e "Desligar" num lugar deixava o outro tocando até o próximo tick.
import axios from "axios";

const API = "/api";
const INTERVALO_MS = 3000;
const VAZIA = { quantidade: 0, clientes: [] };

let estado = VAZIA;
let timer = null;
const ouvintes = new Set();

function cabecalhos() {
  const token = localStorage.getItem("token");
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

function publicar(novo) {
  estado = novo;
  ouvintes.forEach((avisar) => avisar());
}

async function buscar() {
  try {
    const { data } = await axios.get(`${API}/chatbot/waiting-queue`, cabecalhos());
    if (data?.success) publicar({ quantidade: data.count || 0, clientes: data.queue || [] });
  } catch (_) {
    // Falha de rede não zera a fila: o alerta continua até a próxima leitura boa.
  }
}

export function assinarFila(avisar) {
  ouvintes.add(avisar);
  if (!timer) {
    buscar();
    timer = setInterval(buscar, INTERVALO_MS);
  }
  return () => {
    ouvintes.delete(avisar);
    if (ouvintes.size === 0 && timer) {
      clearInterval(timer);
      timer = null;
    }
  };
}

export function lerFila() {
  return estado;
}

export function lerFilaVazia() {
  return VAZIA;
}

export async function dispensarCliente(phone) {
  await axios.delete(`${API}/chatbot/waiting-queue/${encodeURIComponent(phone)}`, cabecalhos());
  const clientes = estado.clientes.filter((c) => c.phone !== phone);
  publicar({ quantidade: clientes.length, clientes });
}

// Backend também zera as pausas do bot desta loja — mesmo efeito do antigo sino do Delivery.
export async function desligarFila() {
  await axios.post(`${API}/chatbot/waiting-queue/clear`, {}, cabecalhos());
  publicar(VAZIA);
}
